var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6375_2496)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.4925,
    cy: 17.3245,
    r: 16.0037,
    fill: "white",
    stroke: "#465668",
    strokeWidth: 2.13382
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.493,
    cy: 17.325,
    r: 5.86801,
    fill: "#465668"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6375_2496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.1412,
    height: 34.1412,
    fill: "white",
    transform: "translate(0.421875 0.253906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepChecked);
export default __webpack_public_path__ + "static/media/stepChecked.24a4a58c92c9ac0661b02f6667080fff.svg";
export { ForwardRef as ReactComponent };